import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc, setDoc, doc, getDoc, deleteDoc, updateDoc, getDocs, query, where, onSnapshot } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCo7LYZdP4Ql9OIiIU-zo-Dvf4Tq7R2suk",
  authDomain: "restaurant-management-sy-372c7.firebaseapp.com",
  projectId: "restaurant-management-sy-372c7",
  storageBucket: "restaurant-management-sy-372c7.firebasestorage.app",
  messagingSenderId: "633215899866",
  appId: "1:633215899866:web:74a5deeb10038d39616de3",
  measurementId: "G-9XCKGEREMK"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, auth, collection, addDoc, setDoc, doc, getDoc, deleteDoc, updateDoc, getDocs, query, where, onSnapshot, storage };